
import { useState } from "react";
import { type SegmentCategory } from "./use-segment-data";

export type RegistrationType = "PF" | "PJ" | null;

export function useRegistrationFlow() {
  const [selectedSegment, setSelectedSegment] = useState<string | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<SegmentCategory>("Medicina");
  const [registrationType, setRegistrationType] = useState<RegistrationType>(null);

  const resetFlow = () => {
    setSelectedSegment(null);
    setRegistrationType(null);
  };

  return {
    selectedSegment,
    setSelectedSegment,
    selectedCategory,
    setSelectedCategory,
    registrationType,
    setRegistrationType,
    resetFlow,
  };
}
